import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CachedCRUDService } from '../../../types/cached-c-r-u-d.service';
import { ParametricsInterface } from '../../../types/parametrics.interface';
import { ServerResponse } from '../../../types/http.interfaces';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProviderTypeService extends CachedCRUDService<ParametricsInterface, never, never> {
  constructor(private http: HttpClient) {
    super();
  }

  protected override async _fetchNewData(): Promise<ParametricsInterface[]> {
    const res: ServerResponse<ParametricsInterface[]> = await lastValueFrom(
      this.http.get<ServerResponse<ParametricsInterface[]>>(
        `${environment.api}/resources-ms/api/v1/parametrics/aphProviderType`
      )
    );
    return res.data;
  }
}
